import React, { FunctionComponent } from 'react'
import { Heading, Modal, Text } from '@afterpaytouch/core'
import { useTranslation, Trans } from '../../../../../utils/convergence'
import { useCheckoutSizes } from '../../../../../utils/responsive'

import styles from './styles.module.css'

interface TradeInModalProps {
  show: boolean
  onClose: () => void
}

export const TradeInModal: FunctionComponent<TradeInModalProps> = ({ show, onClose }) => {
  const { t } = useTranslation(['summary'])
  const { textSize, headingSize } = useCheckoutSizes()

  return (
    <Modal
      show={show}
      onClose={onClose}
      onHide={onClose}
      onBackdropClick={onClose}
      showCloseButton
      closeButtonAriaLabel={t('summary:appleRetail.tradeInModal.closeAriaLabel')}
      testNameSpace='trade-in-modal'
    >
      <Modal.Header>
        <Heading id='modal-label' size={headingSize}>
          {t('summary:appleRetail.tradeInModal.title')}
        </Heading>
      </Modal.Header>
      <Modal.Content>
        <div className={styles.tradeInModalContent}>
          <Text size={textSize}>{t('summary:appleRetail.tradeInModal.intro')}</Text>
          <Text size={textSize}>
            <Trans i18nKey='summary:appleRetail.tradeInModal.matches' components={{ b: <strong /> }} />
          </Text>
          <Text size={textSize}>
            <Trans i18nKey='summary:appleRetail.tradeInModal.lower' components={{ b: <strong /> }} />
          </Text>
          <Text size={textSize}>
            <Trans i18nKey='summary:appleRetail.tradeInModal.higher' components={{ b: <strong /> }} />
          </Text>
          <Text size={textSize}>{t('summary:appleRetail.tradeInModal.accountClosure')}</Text>
          <Text size={textSize}>{t('summary:appleRetail.tradeInModal.help')}</Text>
        </div>
      </Modal.Content>
    </Modal>
  )
}
